import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";

const MyDialog = ({ open, title, children, onDiscard,disableCloseOnBackdrop=false, size = "md" }) => {
  const handleBackdropClose = (event, reason) => {
    if (disableCloseOnBackdrop && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return; // Prevent closing the dialog if backdrop/escape key is clicked
    }
    onDiscard(); // Close dialog for valid reasons
  };

  return (
    <Dialog
      open={open}
      onClose={handleBackdropClose}
      maxWidth={size}
      fullWidth
    >
      {title && 
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}>
        <DialogTitle>{title}</DialogTitle> 
        <Button variant="contained" color="error" onClick={onDiscard}>x</Button>
        </div>}
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
};

MyDialog.propTypes = {
  open: PropTypes.bool.isRequired, // Controls dialog visibility
  title: PropTypes.string, // Optional title for the dialog
  children: PropTypes.node, // Content (form or other components)
  onDiscard: PropTypes.func.isRequired, // Discard button callback
  size: PropTypes.string, // Size of the dialog (e.g., 'sm', 'md', 'lg')
};

export default MyDialog;
